var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{'active': _vm.active_value},on:{"click":function($event){return _vm.toggleActiveValue()}}},[(_vm.active_value)?_c('span',{staticClass:"fa fa-check"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }